import { HttpErrorResponse } from '@angular/common/http';

export function errorMessage(error: unknown, fallback: string): string {
  if (error instanceof HttpErrorResponse) {
    const message = error.error?.message ?? error.error?.detail;
    if (typeof message === 'string' && message.length > 0) {
      return message;
    }
    if (error.status === 0) {
      return 'The AI is offline. Start the API and try again.';
    }
  }
  return fallback;
}
